import type React from 'react';
import { useCallback } from 'react';

import type { ColorName } from 'styles/config/colors';

import { IconButton } from '../IconButton';
import { CopyIcon } from '../Icons';
import { Body } from '../LegacyText';
import Tooltip from '../Tooltip';
import * as Styled from './CopyBox.styled';

export interface CopyBoxProps {
  copyText: string;
  backgroundColor?: ColorName;
}

const CopyBox: React.FC<CopyBoxProps> = ({ copyText, backgroundColor }) => {
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(copyText);
  }, [copyText]);
  return (
    <Styled.CopyBoxWrapper $background={backgroundColor}>
      <Body>{copyText}</Body>
      <Tooltip
        content="Copied to clipboard"
        data-test-id="copy-btn"
        trigger={['click']}
      >
        <IconButton data-test-id="copy-button" onClick={handleCopy}>
          <CopyIcon />
        </IconButton>
      </Tooltip>
    </Styled.CopyBoxWrapper>
  );
};

export default CopyBox;
